var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.43 4.08221C12.2676 4.01195 12.0895 3.98604 11.9138 4.00712C11.7381 4.02821 11.5712 4.09552 11.43 4.20221L6.65 7.98221H3C2.73478 7.98221 2.48043 8.08757 2.29289 8.2751C2.10536 8.46264 2 8.71699 2 8.98221V14.9822C2 15.2474 2.10536 15.5018 2.29289 15.6893C2.48043 15.8769 2.73478 15.9822 3 15.9822H6.65L11.38 19.7622C11.5559 19.9034 11.7744 19.9809 12 19.9822C12.1494 19.9847 12.297 19.9503 12.43 19.8822C12.6002 19.8012 12.744 19.6737 12.8448 19.5144C12.9457 19.3552 12.9995 19.1707 13 18.9822V4.98221C12.9995 4.79372 12.9457 4.60923 12.8448 4.44999C12.744 4.29075 12.6002 4.16326 12.43 4.08221ZM11 16.9022L7.62 14.2022C7.44406 14.061 7.22556 13.9835 7 13.9822H4V9.98221H7C7.22556 9.9809 7.44406 9.90337 7.62 9.76221L11 7.06221V16.9022Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.2676C16.5978 10.6134 17 11.2597 17 12C17 12.7403 16.5978 13.3866 16 13.7324",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6.34131C19.3304 7.16498 21 9.38746 21 11.9999C21 14.6123 19.3304 16.8348 17 17.6585",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOn);
export default __webpack_public_path__ + "static/media/volume-on.b2775f5f.svg";
export { ForwardRef as ReactComponent };